window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap-sass/assets/javascripts/bootstrap.js');

window.Resumable = require('resumablejs');
require('./resumable-custom');
require('jquery-serializejson');
require('viewerjs');
require('jquery-viewer');

window.Swal = require('sweetalert2');
require('block-ui');

require('select2');

require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.es.js');
require('inputmask');
